import { useFormik } from "formik";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../../assets/images/logo/logo-white.png";
import "../../index.css";
import { OtpScheme } from '../Components/Schemes/OTPscheme';
import Routes from "../Components/data/remote/Routes";
import { ToastContainer, toast } from 'react-toastify';
import { Puff } from 'react-loader-spinner';

const notify = (message, type) => {
    // alert('error', +message)
    type == "success" ? toast.success(message, {

        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",

    })
        :
        toast.error(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            closeButton: false,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",

            style: {
                backgroundColor: '#D92533'
            }
        });
}
const OTP = () => {
    const initialValues = {
        otp: ''
    };
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const toggleConfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    };
    const history = useNavigate();

    const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
        useFormik({
            initialValues,
            validationSchema: OtpScheme,
            validateOnChange: true,
            validateOnBlur: false,
            onSubmit: (values, action) => {
                setLoading(true);
                //Calling Login Api
                var formdata = new FormData();
                formdata.append("otp", values.otp);

                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(Routes.OTP, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status == true) {
                            history("/create-new-password", { state: result });
                            // console.log(result)
                            notify(result.message, "success");
                            setLoading(false);

                        } else {
                            notify(result.message, "error");
                            setLoading(false);

                        }

                    })
                    .catch(error => {
                        console.log('error', error)
                        setLoading(false);
                    });
            },
        });

    // console.log(errors);

    return (
        <div className="container-fluid loginpage">
            <ToastContainer
            />
            {loading &&
                <div className="loaderScreen">
                    <Puff
                        height={80}
                        width={80}
                        color="rgba(0, 120, 207, 1)"
                        ariaLabel="puff-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            }
            <div className="col-sd-3 col-md-6 col-lg-4  container card card-forget d-flex justify-content-center">
                <div style={{ textAlign: 'center', display: 'flex', justifyContent: "center", alignItems: 'center', textAlign: 'center' }}>
                    <Link to={'/'} style={{ width: '50%' }}>
                        <img src={logo1} className=" " alt="..." />
                    </Link>
                </div>
                <Link to={'/'}><h5 className="card-title">AL Asab</h5></Link>
                <form onSubmit={handleSubmit} className="card-body card-body-forget" noValidate>
                    <div className="login-text-area ">
                        <label for="validationDefaultEmail" className="form-label">
                            <strong className="login-text">Enter OTP </strong>
                        </label>
                        <input
                            type="number"
                            className="form-control loginEmailInput"
                            id="validationDefaultEmail"
                            placeholder="Enter"
                            required
                            name="otp"
                            value={values.otp}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {errors.otp && touched.otp ? (
                            <p className="form-error">{errors.otp}</p>
                        ) : null}
                    </div>
                    <h6>OTP is sent to Registered Email ID</h6>


                    <div className="forgetSubminBtnMain">
                        <button className="forgetSubmit-button " type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default OTP;
